import styled from "styled-components";

const TodoContainer = styled.div`
  width: 95vw;
  height: 80vh;
  background-color: #242d2e;
  border-radius: 5px;
`;

export default TodoContainer;
